import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';

import { RestService } from "src/app/service/RestService";
import { User } from 'src/app/model/user';
import { Admin } from 'src/app/model/admin';
import { environment } from 'src/environments/environment';
import { UserServiceLocal } from './UserServiceLocal';

@Injectable({ providedIn: 'root' })
export class UserService extends RestService {
  userServiceLocal : UserServiceLocal = new UserServiceLocal();

  public getUserInfo(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.getUserInfo(user);
    }

    const params = new HttpParams();
    const headers = new HttpHeaders();
    return this.restGet(environment.api.getUserInfo, headers, params);
  }

  public register(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.register(user);
    }
    
    return this.restPost(environment.api.register, user);
  }

  public updateUserInfo(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.updateUserInfo(user);
    } 
    
    return this.restPost(environment.api.updateUserInfo, user);
  }

  public updateEmail(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.updateEmail(user);
    } 

    return this.restPost(environment.api.updateEmail, user);
  }

  public changePassword(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.changePassword(user);
    } 
    
    return this.restPost(environment.api.changePassword, user);
  }

  public resetPassword(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.resetPassword(user);
    } 

    return this.restPost(environment.api.resetPassword, user);
  }

  public forgotPassword(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.forgotPassword(user);
    } 

    return this.restPost(environment.api.forgotPassword, user);
  }

  public getUserRoles(user: User) {
    if (environment.env == "local") {
      return this.userServiceLocal.getUserRoles(user);
    } 

    const params = new HttpParams();
    const headers = new HttpHeaders();
    return this.restGet(environment.api.getUserRoles, headers, params);
  }

  public validateEmailMFA(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.validateEmailMFA(user);
    } 

    return this.restPost(environment.api.validateEmailMFA, user);
  }

  public sendEmailMFA(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.sendEmailMFA(user);
    } 

    const params = new HttpParams();
    const headers = new HttpHeaders();
    return this.restGet(environment.api.sendEmailMFA, headers, params);
  }

  public checkEmail(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.checkEmail(user);
    } 

    const params = new HttpParams();
    return this.restPost(environment.api.checkEmail, user);
  }

  public roleReqAuthz(admin: Admin): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.roleReqAuthz(admin);
    } 

    const params = new HttpParams();
    return this.restPost(environment.api.roleReqAuthz, admin);
  }

  public getRestrictedEmailDomains(): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.getRestrictedEmailDomains();
    } 

    const params = new HttpParams();
    const headers = new HttpHeaders();
    return this.restGet(environment.api.getRestrictedEmailDomains, headers, params);
  }

  public getMyServices(): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.getMyServices();
    } 

    const params = new HttpParams();
    return this.restPost(environment.api.getMyservices, null);
  }

  public setNewPassword(user: User): Observable<any> {
    if (environment.env == "local") {
      return this.userServiceLocal.setNewPassword(user);
    } 

    let params = {
      "email": user.email,
      "newPassword": user.newPassword,
      "confirmNewPassword": user.confirmNewPassword,
      "temporaryPassword": user.temporaryPassword,
    };

    return this.restPost(environment.api.setNewPassword, params);
  }

}
